





















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CampaignInfoPopup from '@campaigns/shared/components/CampaignInfoPopup.vue';
import { Campaign, CampaignTableRow, Nullable } from '@/app/shared/utilities/static-types';
import { SYSTEM_STATUS } from '@/app/shared/utilities/object-factory';
import { AdminRoutes } from '@/app/shared/utilities/routes-names';
import namespace from '@/app/shared/store/namespace';
import { FirebaseAppFirestore } from '@/app/shared/firebase/firebase-app';
import firebaseNames from '@/app/shared/utilities/firebase-names';
import ChangeCampaignStartDatePopup from '@campaigns/shared/components/ChangeCampaignStartDatePopup.vue';
import { downloadEstimate, downloadInvoice } from '@campaigns/shared/actions';
import { downloadPdfFromBase64 } from '@/app/shared/utilities/helper-functions';

@Component({
  components: {
    CampaignInfoPopup,
    ChangeCampaignStartDatePopup,
  },
})
export default class TableActions extends Vue {

  public get isCampaignPendingPayment(): boolean {
    return this.campaignRow.STATUS.VAL === SYSTEM_STATUS.PENDING_PAYMENT.VAL;
  }

  private get campaignRef() {
    const { ADVERTISER_UID, ID } = this.campaignRow;
    return FirebaseAppFirestore
      .collection(firebaseNames.CAMPAIGNS.VAL)
      .doc(ADVERTISER_UID)
      .collection(firebaseNames.CAMPAIGNS.USER_CAMPAIGNS)
      .doc(ID);
  }
  @Prop({ required: true, default: () => ({}) }) public campaignRow!: CampaignTableRow;
  @Prop({ required: true, default: false }) public isCampaignOwner!: boolean;

  public advertiserReviewCampaignRoute = AdminRoutes.ADVERTISER_CAMPAIGN_REVIEW;
  public selectedCampaign: Nullable<Campaign> = null;
  public downloadInvoiceLoading = false;
  public downloadEstimateLoading = false;
  public snackbar = false;
  public snackbarMsg = '';

  public showChangeCampaignStartDatePopup(): void {
    this.selectedCampaign = this.campaignRow;
    (this.$refs.changeCampaignStartDatePopup as ChangeCampaignStartDatePopup).open();
  }

  public showCampaignMediaPopup(): void {
    this.selectedCampaign = this.campaignRow;
    (this.$refs.campaignMediaPopup as CampaignInfoPopup).open();
  }

  public reviewCampaign(id: string): void {
    this.setCampaignRef();
    this.$router.push({ ...this.advertiserReviewCampaignRoute, params: { id } });
  }
public async downloadCampaignEstimate(estimateNumber: Exclude<Campaign['ESTIMATE_NUMBER'], undefined>) {
    try {
      this.downloadEstimateLoading = true;
      const pdf = await downloadEstimate(estimateNumber);

      downloadPdfFromBase64(pdf, `${estimateNumber}.pdf`);
      this.snackbar = true;
      this.snackbarMsg = this.$t('estimate_downloaded_successfully').toString();
    } finally {
      this.downloadEstimateLoading = false;
    }

  }

  public async downloadCampaignInvoice(invoiceNumber: Exclude<Campaign['INVOICE_NUMBER'], undefined>) {
    try {
      this.downloadInvoiceLoading = true;
      const pdf = await downloadInvoice(invoiceNumber);

      downloadPdfFromBase64(pdf, `${invoiceNumber}.pdf`);
      this.snackbar = true;
      this.snackbarMsg = this.$t('invoice_downloaded_successfully').toString();
    } finally {
      this.downloadInvoiceLoading = false;
    }
  }

  private setCampaignRef() {
    this.$store.commit(
      `${namespace.CampaignModule}/setCurrentStoreCampaignRef`,
      this.campaignRef,
    );
  }
}
